import { useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { useAPIClient } from "render/context/APIContext";
import { ExtractBody, ExtractKey, QueryOptions } from "typings/query";

export function useCreateNekoLensAuthUrl<T = Body>(
  options?: QueryOptions<Body, Key, T>
) {
  const apiClient = useAPIClient();

  return useQuery({
    queryKey: queryKey(),
    queryFn: queryFn(apiClient),
    staleTime: 4 * 60 * 1000,
    ...options,
  });
}

const queryFn = (apiClient: APIClient) => async () => {
  const url = await apiClient.nekoScope.createAuthUrl().result;
  return url.substring(1, url.length - 1); // Remove quotes added by APIBackend
};
const queryKey = () => ["nekoScopeAuthUrl"];
type Body = ExtractBody<typeof queryFn>;
type Key = ExtractKey<typeof queryKey>;
